export interface IrrigationZone {
  id: string;
  name: string;
  field_name: string;
  hydraulic_group: string;
  area_ha: number;
  flow_rate_lpm: number; // débit en litres par minute
}

export const ZONES: IrrigationZone[] = [
  { id: 'zone-a1', name: 'Zone A-1', field_name: 'Domaine Les Vignes - Nord', hydraulic_group: 'Groupe A', area_ha: 2.5, flow_rate_lpm: 22 },
  { id: 'zone-a2', name: 'Zone A-2', field_name: 'Domaine Les Vignes - Sud', hydraulic_group: 'Groupe A', area_ha: 1.8, flow_rate_lpm: 18 },
  { id: 'zone-b1', name: 'Zone B-1', field_name: 'Coopérative Hérault - Est', hydraulic_group: 'Groupe B', area_ha: 3.2, flow_rate_lpm: 28 },
  { id: 'zone-b2', name: 'Zone B-2', field_name: 'Coopérative Hérault - Ouest', hydraulic_group: 'Groupe B', area_ha: 2.1, flow_rate_lpm: 20 },
  { id: 'zone-c1', name: 'Zone C-1', field_name: 'Exploitation Gard Sud', hydraulic_group: 'Groupe C', area_ha: 4.1, flow_rate_lpm: 32 },
];
